import { render, staticRenderFns } from "./BePlaceholderAppointmentList.vue?vue&type=template&id=2d5c6b43&scoped=true"
import script from "./BePlaceholderAppointmentList.vue?vue&type=script&lang=js"
export * from "./BePlaceholderAppointmentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5c6b43",
  null
  
)

export default component.exports